const removeFalsyKeys = (obj: Record<string, any>) => (Object.entries(obj).reduce((acc,[key, value]) => ({...acc, ...(!value ? {} : {[key]: value})}), {}))

const script =
  document.currentScript ||
  (() => {
    const scripts = document.getElementsByTagName("script");

    return scripts[scripts.length - 1];
  })();

if (script && script instanceof HTMLScriptElement) {
  const matches = script.src.match(/id=([\w\d]+)&apiUrl=([\w\d:\/.-]+)/);


  if (matches && matches.length >= 3) {
    const id = matches[1];
    const apiUrl = matches[2];
    const search = new URLSearchParams(window.location.search)
    const customerId = search.get("salesmatch.ai")
    const origin = search.get("origin")

    const urlSearch = new URLSearchParams(removeFalsyKeys({
      customerId,
      id,
      origin
    }))

    fetch(`${apiUrl}/pl:inbox/script-manager?${urlSearch.toString()}`)
      .then(res => res.text())
      .then(text => {
        const scrpt = document.createElement("script");

        scrpt.innerHTML = text;

        (document.body as any).append(scrpt);
      });
  }
}
